import React from "react";

const PortfolioSection = () => {

    const portfolioData = [
        {
            title: "Food Delivery App",
            category: "Mobile App",
            image:
                "https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=1200&auto=format&fit=crop",
            tech: ["React Native", "Firebase", "Node.js"],
        },
        {
            title: "Fitness Tracking App",
            category: "Health & Fitness",
            image:
                "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?q=80&w=1200&auto=format&fit=crop",
            tech: ["Flutter", "AWS", "MongoDB"],
        },
        {
            title: "E-Commerce Mobile App",
            category: "Shopping App",
            image:
                "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=1200&auto=format&fit=crop",
            tech: ["Kotlin", "Laravel", "MySQL"],
        },
        {
            title: "Fintech Banking App",
            category: "Finance",
            image:
                "https://images.unsplash.com/photo-1559526324-593bc073d938?q=80&w=1200&auto=format&fit=crop",
            tech: ["Swift", "Stripe", "AWS"],
        },
    ];

    return (
        <>
            <section className="portfolio-section">

                {/* Background Effects */}
                <div className="portfolio-blur portfolio-blur-1"></div>
                <div className="portfolio-blur portfolio-blur-2"></div>

                <div className="portfolio-container">

                    {/* Heading */}
                    <div className="portfolio-heading">

                        <span className="portfolio-badge">
                            OUR APP PORTFOLIO
                        </span>

                        <h2 style={{ textAlign: "center" }}>
                            Apps Crafted To<br />
                            <span> Inspire Millions.</span>
                        </h2>

                        <p style={{ textAlign: "center" }}>
                            We create premium mobile applications with
                            world-class UI/UX, performance & scalability.
                        </p>

                    </div>

                    {/* Portfolio Grid */}
                    <div className="portfolio-grid">

                        {portfolioData.map((item, index) => (
                            <div
                                className={`portfolio-card portfolio-card-${index + 1}`}
                                key={index}
                            >

                                {/* Image */}
                                <div className="portfolio-image-wrap">

                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="portfolio-image"
                                    />

                                    <div className="portfolio-overlay"></div>

                                    <div className="portfolio-floating-icon">
                                        📱
                                    </div>

                                </div>

                                {/* Content */}
                                <div className="portfolio-content">

                                    <span className="portfolio-category">
                                        {item.category}
                                    </span>
                                    <h3>{item.title}</h3>
                                    <div className="portfolio-tech">
                                        {item.tech.map((tech, i) => (
                                            <span key={i}>
                                                {tech}
                                            </span>
                                        ))}
                                    </div>
                                    <div className="portfolio-bottom">
                                        <a href="/Portfolio">
                                            View Project →
                                        </a>
                                        <div className="portfolio-arrow">
                                            ↗
                                        </div>
                                    </div>
                                </div>

                                {/* Hover Border */}
                                <div className="portfolio-border"></div>

                            </div>
                        ))}

                    </div>

                    {/* Bottom CTA */}
                    {/* <div className="portfolio-cta">

                    <div className="portfolio-cta-card">

                        <div className="cta-glow"></div>

                        <h3 style={{ textAlign: "center" }}>
                            Have an App Idea?
                        </h3>

                        <p style={{ textAlign: "center" }}>
                            Let’s transform your vision into a
                            next-generation mobile experience.
                        </p>

                        <a href="#">
                            Start Your Project
                        </a>

                    </div>

                </div> */}

                </div>

            </section>
        </>
    );
};

export default PortfolioSection;